module.exports = __webpack_public_path__ + "img/v5.0e45f914.jpg";